import React, { useState } from "react";
import PrimaryButton from "../buttons/PrimaryButton";
import PdfEditor from "./model/PdfEditor";
import getTemporaryUrl from "../api/getTemporaryUrl";
import { useAppContext } from "../config/AppContext";
import { getDocDataById } from "../models/DataFunctions";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import Modal1 from "../modals/Modal1";
import SmallSpinner from "../loading/SmallSpinner";
const PreSignXmlModal = ({
  document,
  children,
  folder,
  orgData,
  setModalOpen,
  onFetch,
  userData,
}) => {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState(null);
  const [fileName, setFileName] = useState(null);
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [folderData, setFolderData] = useState(null);
  const [loading_fetch, setLoadingFetch] = useState(false);
  const fetchUrl = async () => {
    setLoadingFetch(true);
    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(token, "last_file_extracted", "", folder.id, prefix);
    let folderData = await getDocDataById("folder", folder.id);
    setFolderData(folderData);
    setUrl(folderData.last_file_extracted.url);
    setFileName(folderData.last_file_extracted.name);
    setOpen(true);
    setModalOpen(true); // Notify parent that modal is open
    setLoadingFetch(false);
  };

  const handleOpen = async (e) => {
    e.stopPropagation();
    await fetchUrl();
  };

  const handleFetchAgain = () => {
    onFetch();
    setOpen(false);
    setModalOpen(false); // Notify parent that modal is closed
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    document && (
      <div className="w-fit min-w-fit h-full justify-center  items-center align-middle bg-transparent">
        {/* Button to open the modal */}
        <div className="h-fit min-w-fit w-fit cursor-pointer bg-transparent">
          <PrimaryButton
            onClick={handleOpen}
            sx={{
              fontSize: "13px",
              borderRadius: "8px",
              minWidth: "80px",
            }}
            disabled={loading_fetch}
          >
            Préparer avec le xml extrait{" "}
            <SmallSpinner loading={loading_fetch} size={20} />
          </PrimaryButton>
          {children}
        </div>
        <Modal1 isOpen={open} onClose={handleClose}>
          <div className="p-4 rounded-xl w-screen h-screen  ">
            <PdfEditor
              file_url={url}
              folder={folderData}
              document={document}
              onClose={handleClose}
              onFetch={handleFetchAgain}
              userData={userData}
              from_extract={true}
              fileName={fileName}
            />{" "}
          </div>
          {/* This is where the PdfEditor will be rendered */}
        </Modal1>
      </div>
    )
  );
};

export default PreSignXmlModal;
